import { put, takeLatest, call } from 'redux-saga/effects'

import * as orderService from '../../../services/orderService'
import {
  DELIVER_ORDER,
  DELIVER_ORDER_SUCCESS,
  DELIVER_ORDER_ERROR
}
  from '../../actions/order'

function * deliverOrderSaga (action) {
  try {
    const data = yield call(orderService.DeliverOrder, action.payload)

    yield put({
      type: DELIVER_ORDER_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: DELIVER_ORDER_ERROR, error: error.data
    })
  }
}

export function * deliverOrderSagaWatcher () {
  yield takeLatest(DELIVER_ORDER, deliverOrderSaga)
}
